import React from 'react';

const FailedBig = props => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill="#CB2C2C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1072 11.5648C12.6755 11.2291 12.0512 11.2596 11.6544 11.6564C11.2246 12.0862 11.2246 12.7831 11.6544 13.2129L14.4422 16.0007L11.6544 18.7884L11.5628 18.8921C11.2271 19.3239 11.2576 19.9482 11.6544 20.345C12.0842 20.7748 12.7811 20.7748 13.2109 20.345L15.9987 17.5572L18.7865 20.345L18.8902 20.4365C19.3219 20.7722 19.9462 20.7417 20.343 20.345C20.7728 19.9151 20.7728 19.2182 20.343 18.7884L17.5552 16.0007L20.343 13.2129L20.4346 13.1092C20.7703 12.6774 20.7398 12.0531 20.343 11.6564C19.9132 11.2265 19.2163 11.2265 18.7865 11.6564L15.9987 14.4441L13.2109 11.6564L13.1072 11.5648Z"
      fill="white"
    />
  </svg>
);

export default FailedBig;
